import AXIOS_INSTANCE from '../api/axiosInstance'
import { queryClient } from '../store/provider/TanStackProvider'
import { useMutation, useQuery } from '@tanstack/react-query'
import { CsvUploadRes } from '../types/csv_upload.type'

type Args = {
  context: string
  invalidateQueryKey?: any[]
  enabled?: boolean
}

export const useBulkUpload = ({ context, invalidateQueryKey, enabled = false }: Args) => {
  const { isFetching, isLoading: isQueryLoading } = useQuery({
    enabled,
    queryFn: async () => {
      const { data } = await AXIOS_INSTANCE.get(`/${context}/bulk_import`)
      return data
    },
    queryKey: ['bulk_import', { context }],
    retry: false
  })

  const { mutateAsync: bulkImport, isPending: isLoading } = useMutation({
    mutationFn: async (file: File) => {
      const formData = new FormData()
      formData.append('file', file)
      const { data } = await AXIOS_INSTANCE.post<CsvUploadRes>(`/${context}/bulk_import`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      })
      return data
    },
    onSuccess: () => {
      if (invalidateQueryKey?.length) {
        queryClient.invalidateQueries({ queryKey: invalidateQueryKey })
      }
    }
  })

  return { bulkImport, isFetching, isLoading, isQueryLoading }
}
